import Store from 'store';
import SelfCareError from '../SelfCareError';

class LocalStorageService {
	constructor() {
		if (!Store.enabled) {
			throw new SelfCareError('Local storage is not supported by your browser. Please disable "Private Mode", or upgrade to a modern browser.');
		}
		this.CURRENT_CUSTOMER = "sc_currentCustomer";
		this.CURRENT_CONTACT= "sc_currentContact";
		this.SOURCE = "sc_source";
	}

	get(key, defaultValue) {
		return Store.get(key, defaultValue);
	}

	set(key, value) {
		Store.set(key, value);
	}

	remove(key) {
		Store.remove(key);
	}

	getCurrentCustomer() {
		return this.get(this.CURRENT_CUSTOMER);
	}

	setCurrentCustomer(customer) {
		this.set(this.CURRENT_CUSTOMER, customer);
	}

	getSource() {
		return this.get(this.SOURCE);
	}

	removeCurrentCustomer() {
		this.remove(this.CURRENT_CUSTOMER);
		this.remove(this.CURRENT_CONTACT);
		this.remove(this.SOURCE);
	}

	setCurrentContact(contact) {
		this.set(this.CURRENT_CONTACT, contact);
	}

	getCurrentContact() {
		return this.get(this.CURRENT_CONTACT);
	}
}

const localStorageService = new LocalStorageService();

export default localStorageService;



// WEBPACK FOOTER //
// ./src/opencell/services/LocalStorageService.js